module.exports = __webpack_public_path__ + "img/06_uk.cd21e5fd.svg";